const runtimeConfig = typeof window !== "undefined" && window.__APP_CONFIG__ ? window.__APP_CONFIG__ : {};

const getValue = (runtimeKey, envKey) => {
    if (runtimeConfig[runtimeKey] !== undefined && runtimeConfig[runtimeKey] !== null && runtimeConfig[runtimeKey] !== "") {
        return runtimeConfig[runtimeKey];
    }
    return process.env[envKey];
};

export default {
	tenant: getValue("tenant", "REACT_APP_TENANT_ID"),
	clientId: getValue("clientId", "REACT_APP_CLIENT_ID"),
	scope: getValue("scope", "REACT_APP_SCOPE"),
	apimKey: getValue("apimKey", "REACT_APP_APIM_KEY"),
	datedFlightBaseUrl: getValue("datedFlightBaseUrl", "REACT_APP_DATED_FLIGHT_BASE_URL"),
	outageStart: getValue("outageStart", "REACT_APP_OUTAGE_START"),
	outageEnd: getValue("outageEnd", "REACT_APP_OUTAGE_END"),
	redirectURI: getValue("redirectURI", "REACT_APP_REDIRECT_URI")
}